var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'overlay-image': _vm.isDragging },style:({
    position: 'absolute',
    width:_vm.overlay.width,
      left: _vm.overlay.position.x + 'px',
    top: _vm.overlay.position.y + 'px',
     border: _vm.isSelected ? '2px solid blue' : 'none'
  }),attrs:{"src":_vm.overlay.imageUrl},on:{"contextmenu":function($event){$event.preventDefault();return _vm.handleContextMenu.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }